import { render, staticRenderFns } from "./other.vue?vue&type=template&id=021a7088&scoped=true"
import script from "./other.vue?vue&type=script&setup=true&lang=ts"
export * from "./other.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./other.vue?vue&type=style&index=0&id=021a7088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021a7088",
  null
  
)

export default component.exports